var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-fluid loading-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"cube1"}),_c('div',{staticClass:"cube2"})])])])
}]

export { render, staticRenderFns }